<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="suggestIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>阳光互动</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="shine_part1">
            <ul>
              <li><a href="javascript:void(0)" @click="urlTo('/suggest_zx',{title:'咨询',type:4,source:1})"><img src="../../static/images/shine_pic1.png"></a></li>
              <li><a href="javascript:void(0)" @click="urlTo('/suggest_ts',{title:'投诉',type:1,source:1})"><img src="../../static/images/shine_pic2.png"></a></li>
              <li><a href="javascript:void(0)" @click="urlTo('/suggest',{title:'建议',type:2,source:1})" ><img src="../../static/images/shine_pic3.png"></a></li>
            </ul>
          </div>
          <div class="shine_part2">
            <div>
              <p class="trangle">&nbsp;</p>
              <dl>
                <dt><span><img src="../../static/images/shine_sign1.png">咨询</span><a @click="urlTo('suggestList',{type:4})" href="javascript:void(0)">更多 ···</a></dt>
                <dd v-for="(item,index) in zxData" :key="item.id"><a @click="urlTo('suggestDetail',{detail_id:item.id,type:4})" href="javascript:void(0)">
                  <span>{{item.title}}</span>
                  <em>{{item.time}}</em></a>
                </dd>
              </dl>
            </div>
            <div>
              <p class="trangle">&nbsp;</p>
              <dl>
                <dt><span><img src="../../static/images/shine_sign2.png">投诉</span><a @click="urlTo('suggestList',{type:1})"  href="javascript:void(0)">更多 ···</a></dt>
                <dd v-for="(item,index) in tsData" :key="item.id"><a  @click="urlTo('suggestDetail',{detail_id:item.id,type:1})" href="javascript:void(0)">
                  <span>{{item.title}}</span>
                  <em>{{item.time}}</em></a>
                </dd>
              </dl>
            </div>
            <div>
              <p class="trangle">&nbsp;</p>
              <dl>
                <dt><span><img src="../../static/images/shine_sign3.png">建议</span><a @click="urlTo('suggestList',{type:2})" href="javascript:void(0)">更多 ···</a></dt>
                <dd v-for="(item,index) in jyData" :key="item.id"><a @click="urlTo('suggestDetail',{detail_id:item.id,type:2})" href="javascript:void(0)">
                  <span>{{item.title}}</span>
                  <em>{{item.time}}</em></a>
                </dd>
              </dl>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
let id = 0;

export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      pageNum:1,
      pageSize:6,
      tsData:[],
      jyData:[],
      zxData:[]
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  created(){
    this.initData();
  },
  methods: {
    initData(){
      var t=this;
      const options={pageSize:this.pageSize,pageNum:this.pageNum}
      this.$https.post("api/suggest/getSuggestIndex.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.ts && response.data.data.ts.length>0){
            t.tsData=response.data.data.ts;
          }
          if(response.data.data.jy && response.data.data.jy.length>0){
            t.jyData=response.data.data.jy;
          }
          if(response.data.data.zx && response.data.data.zx.length>0){
            t.zxData=response.data.data.zx;
          }
        } else {
          // t.departOption =[];
        }
      })
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/SuggestIndex.vue